import { render, staticRenderFns } from "./ShipmentItems.vue?vue&type=template&id=f1f997ea&scoped=true"
import script from "./ShipmentItems.vue?vue&type=script&lang=js"
export * from "./ShipmentItems.vue?vue&type=script&lang=js"
import style0 from "./ShipmentItems.vue?vue&type=style&index=0&id=f1f997ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f997ea",
  null
  
)

export default component.exports